import React, {useContext, useState} from 'react'
import CartItem from '../components/CartItem/CartItem.jsx'
import {StateContext} from '../context/GlobalState.jsx'
import {GetText} from "../context/text.js";

function Cart() {
    // consuming contexts
    let {total, cartItems, totalItems, resetCart, checkOutCart, courseUSD, lang} = useContext(StateContext);

    let text = GetText();

    const [nameCustomer, setNameCustomer] = useState('Покупатель');
    const [telCustomer, setTelCustomer] = useState(''); // Пустая строка по умолчанию для корректной проверки
    const [errorMessage, setErrorMessage] = useState(''); // Для отображения ошибок

    const newOrder = {
        cartItems: cartItems,
        nameCustomer: nameCustomer,
        telCustomer: telCustomer,
        totalItems: totalItems,
        total: total
    };

    const handleCheckout = () => {
        let errorMessage = '';

        // Проверяем значение lang и устанавливаем сообщение об ошибке в зависимости от языка
        switch (lang) {
            case 'ua':
                errorMessage = 'Телефон обов\'язковий для заповнення';
                break;
            case 'ru':
                errorMessage = 'Телефон обязателен для заполнения';
                break;
            case 'en':
                errorMessage = 'Phone number is required';
                break;
            default:
                errorMessage = 'Phone number is required'; // Значение по умолчанию, если язык не поддерживается
        }

        // Проверяем, заполнено ли поле телефона
        if (!telCustomer) {
            setErrorMessage(errorMessage); // Устанавливаем сообщение об ошибке
            return;
        }

        setErrorMessage(''); // Очищаем ошибку, если поле заполнено
        checkOutCart(newOrder); // Выполняем оформление заказа
    };

    // render JSX
    return (
        <>
            <section className="cart-section">
                {
                    cartItems.map((item) => <CartItem key={item.ID} item={item}/>)
                }

                <div className="summary-detail-cart">
                    {
                        totalItems !== 0 ? (
                            <div className="items">
                                <p>
                                    <input
                                        type="text"
                                        placeholder={text.Cart.namePlaceholder}
                                        required
                                        onChange={e => setNameCustomer(e.target.value)}
                                    />
                                </p>
                                <p>
                                    <input
                                        type="tel"
                                        placeholder={text.Cart.telPlaceholder}
                                        required
                                        value={telCustomer}
                                        onChange={e => setTelCustomer(e.target.value)}
                                    />
                                </p>
                                {errorMessage && <p style={{color: 'red'}}>{errorMessage}</p>} {/* Вывод сообщения об ошибке */}
                            </div>
                        ) : (
                            <div className="items"></div>
                        )
                    }

                    <div className="items padTop">
                        {
                            totalItems === 0 ? <h4 className="warn-txt">{text.Cart.noItem}</h4> :
                                <h4>{text.Cart.totalItems}: {totalItems}</h4>
                        }
                    </div>

                    <div className="amounts">
                        { lang === "ua" && <h4>{text.Cart.total}: {total * courseUSD} грн</h4> }
                        { lang === "ru" && <h4>{text.Cart.total}: {total * courseUSD} грн</h4> }
                        { lang === "en" && <h4>{text.Cart.total}: {total * courseUSD} UAH</h4> }
                    </div>

                    {
                        totalItems > 0 && (
                            <>
                                <button onClick={handleCheckout} className="checkout">
                                    {text.Cart.checkout}
                                </button>
                                <button onClick={() => resetCart()} className="reset">
                                    {text.Cart.reset}
                                </button>
                            </>
                        )
                    }
                </div>
            </section>
        </>
    );
}

export default Cart;